import { MassEditFieldInput } from 'common-front/src/components/massEdit/massEditFieldInput';
import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { WorkflowInput } from 'common/src/generated/types';
import * as React from 'react';
import { useWorkflowCustomFieldsQuery } from '../../../generated/graphqlHooks';
import { WorkflowBox } from '../workflowBox';

interface IWorkflowSetCustomFieldStepProps {
    workflow: WorkflowInput;

    change(name: string, value: any): void;
}

export const WorkflowSetCustomFieldStep = (props: IWorkflowSetCustomFieldStepProps) => {
    const {
        translate,
        params: { organizationId }
    } = useHeavent();
    const { data } = useWorkflowCustomFieldsQuery({ organizationId });
    const customFields = React.useMemo(
        () => data.organization?.customFields.nodes ?? [],
        [data.organization]
    );
    const selectedField = customFields.find((cf) => cf.id === props.workflow.data.customFieldId);

    return (
        <WorkflowBox
            category={translate('liste_des_champ_94862')}
            icon="text"
            title={translate('le_champ_suivan_27303')}
        >
            <RichSelect
                isSearchVisible={true}
                label={translate('CustomField')}
                name="workflow.data.customFieldId"
                placeholder={translate('choisir_un_cham_67587')}
            >
                {customFields.map((customField) => (
                    <option key={customField.id} value={customField.id}>
                        {customField.name}
                    </option>
                ))}
            </RichSelect>

            {selectedField && (
                <Flex direction="column" gap="1">
                    <Box font="gray700 textSm medium">
                        {translate('nouvelle_valeur_39039', selectedField.name)}
                    </Box>

                    <MassEditFieldInput
                        campaigns={[]}
                        categories={[]}
                        change={props.change}
                        customDocuments={[]}
                        customField={selectedField}
                        forms={[]}
                        name="workflow.data.customFieldValue"
                        slug={selectedField.slug}
                        tags={[]}
                        traces={[]}
                        value={props.workflow.data?.customFieldValue}
                    />
                </Flex>
            )}
        </WorkflowBox>
    );
};
